import { Button, Flex, Spacer, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import useOrganizationStatus from '../../../hooks/useOrganisationStatus';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import LockedActionButton from '../../common/LockedActionButton';

const EventListHeader = () => {
  const { shouldRender } = useOrganizationStatus();
  const isReadOnly = useIsReadOnly();

  return (
    <Flex
      flexDirection={{ base: 'column', sm: 'row' }}
      alignItems="center"
      flexWrap="wrap"
      mt="15px"
      py="9px"
      minH="54px"
    >
      <Text
        textStyle="heading2"
        alignSelf={{ base: 'flex-start', sm: 'center' }}
      >
        Events
      </Text>
      <Spacer />
      {shouldRender &&
        (isReadOnly ? (
          <LockedActionButton
            reason="create-events"
            alignSelf={{ base: 'flex-start', sm: 'center' }}
            mt={{ base: '12px', sm: '0' }}
            size="sm"
          >
            Create event
          </LockedActionButton>
        ) : (
          <Button
            alignSelf={{ base: 'flex-start', sm: 'center' }}
            mt={{ base: '12px', sm: '0' }}
            alt="Create event"
            size="sm"
            as={RouterLink}
            to="/events/create"
          >
            Create event
          </Button>
        ))}
      {/* {isSetUpConfirmed && <EventsListFilter />} */}
    </Flex>
  );
};
export default EventListHeader;
